import { useFormik } from 'formik';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Textarea } from 'rizzui';
import * as yup from 'yup';
import CustomSelect from '../../../components/forms/CustomSelect';
import RequiredInput from '../../../components/forms/InputHOC';
import Page from '../../../layout/Page/Page';
import FormGroup from '../../../layout/shared/form-group';
import { KoReason } from '../../../type/entities/ko-reason-type';
import FormFooter from '../../_layout/_footers/form-footer';
import { entities as statusEntities } from '../StateForm';

interface KoReasonFormProps {
    isLoading: boolean;
    submit: (values: any) => void;
    data?: KoReason | undefined;
}

const schema = yup.object({
    name: yup.string().required("Este campo es requerido"),
    description: yup.string().nullable(),
    statusEntity: yup.string().required('Debe seleccionar un tipo de estado'),
});

const KoReasonForm: React.FC<KoReasonFormProps> = ({ isLoading, submit, data }) => {

    const mode = data ? 'Editar' : 'Crear';
    const navigate = useNavigate();

    const formik = useFormik({
        initialValues: {
            koReasonId: data?.id || '',
            name: data?.name || '',
            description: data?.description || '',
            statusEntity: data?.statusEntity || '',
            entityOrder: data?.entityOrder ?? 0,
        },
        validationSchema: schema,
        onSubmit: values => submit(values),
        enableReinitialize: true,
    });

    return (
        <>
            <Page container="fluid">
                <div className="@container">
                    <form onSubmit={formik.handleSubmit}>
                        <div className="grid gap-7 divide-y-2 divide-dashed divide-gray-200 font-medium">
                            <FormGroup
                                title="Información General"
                                description="Datos principales"
                                titleCols="@md:col-span-2"
                                childCols="@md:col-span-10 md:grid-cols-4"
                            >
                                <RequiredInput
                                    required={true}
                                    id='name'
                                    formik={formik}
                                    label="Nombre"
                                    className='@md:col-span-4'
                                />
                                <CustomSelect
                                    required
                                    id="statusEntity"
                                    label="Estado"
                                    placeholder="Selecciona el tipo de estado"
                                    options={statusEntities}
                                    value={statusEntities.find((option) => option.value === formik.values.statusEntity) || null}
                                    onChange={(option: any) => formik.setFieldValue('statusEntity', option?.value || '')}
                                    error={formik.touched.statusEntity ? formik.errors.statusEntity as string : undefined}
                                    containerClassName="col-span-4"
                                />
                                <Textarea
                                    id='description'
                                    label="Descripción"
                                    className="[&>label>span]:font-medium col-span-4"
                                    onChange={formik.handleChange}
                                    value={formik.values.description || ''}
                                    error={formik.touched.description && typeof formik.errors.description === 'string' ? formik.errors.description : undefined}
                                />
                            </FormGroup>
                        </div>
                    </form>
                </div>
            </Page>
            <FormFooter
                submitBtnText={mode + ' motivo de KO'}
                handleCancelBtn={() => navigate(-1)}
                handleSubmitBtn={formik.submitForm}
                isLoading={isLoading}
            />
        </>
    );
};

export default KoReasonForm;
